import { render, staticRenderFns } from "./OutpatientReviewGrouping.vue?vue&type=template&id=551e6878&scoped=true&"
import script from "./OutpatientReviewGrouping.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewGrouping.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewGrouping.vue?vue&type=style&index=0&id=551e6878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e6878",
  null
  
)

export default component.exports